import React from 'react';
import styled from 'styled-components';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import CountdownText from './CountdownText';

const BlurredContainer = styled.aside`
  background-color: rgba(15, 17, 36, 0.95);
  backdrop-filter: blur(20px);
`;

const PremiumCTABar: React.FC<{
  message: string;
  buttonLabel: string;
  onClick(): void;
  banner: {
    message: string;
    alternativeShortMessage: string;
    expirationDate: Date;
  } | null;
}> = ({ message, buttonLabel = 'Quiero ser premium', onClick, banner }) => {
  return (
    <BlurredContainer className="w-full px-12 sm:text-right sm:px-24 py-16 flex items-center justify-center sm:justify-end">
      {/* Message */}
      {banner ? (
        <CountdownText banner={banner} />
      ) : (
        <div>
          {/* Responsive text */}
          <p className="font-caption sm:hidden text-white">{message}</p>
          {/* Desktop text */}
          <p className="font-subtitle2 hidden sm:block text-white">{message}</p>
        </div>
      )}
      {/* Main button */}
      <div className="ml-12 sm:ml-24">
        {/* Responsive button */}
        <PrimaryButton
          size="s"
          className="h-48 px-16 sm:hidden"
          darkMode
          label={buttonLabel}
          onClick={onClick}
        />
        {/* Desktop button */}
        <PrimaryButton
          className="hidden sm:block"
          darkMode
          label={buttonLabel}
          onClick={onClick}
        />
      </div>
    </BlurredContainer>
  );
};

export default PremiumCTABar;
